/**
 * assets/handoffs/design_handoff_workspace_settings — restyle onto
 * Untitled UI. Structure/actions unchanged from the legacy page; see
 * OrganizationSettingsPage/ for the two card components.
 */
import React, { useEffect } from "react";
import { useAppStore } from "./../../../hooks/redux/app";
import TabbedSettingsPage from "../templates/TabbedSettingsPage/TabbedSettingsPage";
import { WORKSPACE_SETTINGS_TABS } from "../templates/TabbedSettingsPage/settingsTabs";
import { useCurrentOrganizationStore } from "../../../hooks/redux/currentOrganization";
import { useUserStore } from "../../../hooks/redux/user";
import BasicInformationCard from "./OrganizationSettingsPage/BasicInformationCard";
import DeleteWorkspaceCard from "./OrganizationSettingsPage/DeleteWorkspaceCard";
import styles from "./OrganizationSettingsPage/WorkspacePage.module.scss";

const OrganizationSettingsPage = () => {
  const { clearErrors } = useAppStore();
  const { currentOrganization, editOrganization, deleteOrganization } =
    useCurrentOrganizationStore();
  const { user, changeOrganization } = useUserStore();

  const orgModel = currentOrganization.model || {};

  useEffect(() => {
    return clearErrors;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (currentOrganization.deleteOrganizationSuccess) {
      const switchToOrg = user.model.organizations.find(
        (i) => i.uuid !== currentOrganization.model.uuid
      );
      changeOrganization(switchToOrg.uuid);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentOrganization.deleteOrganizationSuccess]);

  return (
    <TabbedSettingsPage
      title="Workspace settings"
      subtitle="Applies to this workspace and everyone in it."
      tabs={WORKSPACE_SETTINGS_TABS}
    >
      <div className={styles.page}>
        <BasicInformationCard
          orgModel={orgModel}
          currentOrganization={currentOrganization}
          editOrganization={editOrganization}
        />
        <DeleteWorkspaceCard
          orgModel={orgModel}
          currentOrganization={currentOrganization}
          deleteOrganization={deleteOrganization}
        />
      </div>
    </TabbedSettingsPage>
  );
};

export default OrganizationSettingsPage;
